<template>
  <div id="app" >
    <MobileHeader v-if="isMobile"/>
    <HeaderComponent v-else :is-scrolled="isScrolled"/>
    <router-view />
    <MobileFooter v-if="isMobile"/>
    <FooterComponent v-else :is-scrolled="isScrolled"/>
  </div>
</template>

<script>
import HeaderComponent from './components/head.vue'
import MobileHeader from './components/mobile_components/head.vue';
import FooterComponent from './components/footer.vue'
import MobileFooter from './components/mobile_components/footer.vue'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    MobileHeader,
    MobileFooter
  },
  data() {
    return {
      isScrolled: false,
      tabsSticky: false,
      appContainer: null,
      isMobile: false
    }
  },  
  computed: {

  },
  mounted() {
    this.checkDevice();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  
    // 监听 #app 容器的滚动事件
    const appContainer = document.getElementById('app');
    if (appContainer) {
      appContainer.addEventListener('scroll', this.handleScroll);
      // 保存引用以便清理
      this.appContainer = appContainer;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    // 清理滚动事件监听器
    if (this.appContainer) {
      this.appContainer.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    handleScroll() {
      // 使用已保存的引用判断是否滚动离开顶部
      this.tabsSticky = this.appContainer.scrollTop > 780
      let  subtabsSticky = this.appContainer.scrollTop > 2000
      this.isScrolled = this.appContainer.scrollTop > 0;
      document.body.classList.toggle('tabs-sticky', this.tabsSticky);
      document.body.classList.toggle('subtabs-sticky', subtabsSticky);
    },
    checkDevice() {
    // 设定断点，例如 768px 以下为移动端
    this.isMobile = window.innerWidth <= 768;
    },
    // 新增：窗口大小变化处理
    handleResize() {
      this.checkDevice();
    },
  }
}
</script>

<style scoped>
#app {
  width: 100%;
  height: 100vh;
  /* height: 970px; */
  /* 启用垂直滚动条 */
  overflow-x: hidden;
  /* 隐藏水平滚动条 */
}
</style>